import React from "react";

function Line() {
    return (
        <div className="line" data-aos="fade-right">
            <span></span>
            <span></span>
        </div>
    );
}

export default Line;